import { render, staticRenderFns } from "./ProfileOfCompanies.vue?vue&type=template&id=58c84ab2&"
import script from "./ProfileOfCompanies.vue?vue&type=script&lang=js&"
export * from "./ProfileOfCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/buildhome/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAvatar,VFlex,VLayout})
